import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import Routes from '~/routes/routes';
import { ADMIN_URL } from '~/config/config';

import {
    LandingHeader,
    HeroSection,
    TrustedBySection,
    FeaturesSection,
    CTASection,
    FooterSection,
} from './sections';

const HomeScreen: React.FC = () => {
    const navigate = useNavigate();

    const handleNavigateToProjects = () => {
        navigate(Routes.PROJECT);
    };

    const handleNavigateToLogin = () => {
        navigate(Routes.LOGIN);
    };

    const handleNavigateToSignup = () => {
        window.location.href = `${ADMIN_URL}/register`;
    };

    return (
        <div style={{ height: '100vh', overflowY: 'auto', background: '#0b1020' }}>
            {/* Animated background */}
            <motion.div
                style={{
                    position: 'fixed',
                    inset: 0,
                    background:
                        'radial-gradient(circle at 20% 20%, rgba(24,144,255,0.25), transparent 40%),\n             radial-gradient(circle at 80% 30%, rgba(114,46,209,0.25), transparent 40%),\n             radial-gradient(circle at 50% 80%, rgba(82,196,26,0.15), transparent 40%)',
                    zIndex: 0,
                }}
                animate={{ backgroundPosition: ['0% 0%', '100% 100%'] }}
                transition={{ duration: 30, repeat: Infinity, ease: 'linear' }}
            />

            {/* Header với LanguageSelector */}
            <LandingHeader
                onNavigateToLogin={handleNavigateToLogin}
                onNavigateToSignup={handleNavigateToSignup}
            />

            {/* Hero Section - Section 1: Powerful GIS software, made simple */}
            <HeroSection onNavigateToProjects={handleNavigateToProjects} />

            {/* Trusted By Section */}
            <TrustedBySection />

            {/* Features Section */}
            <FeaturesSection />

            {/* CTA Section */}
            <CTASection onNavigateToProjects={handleNavigateToProjects} />

            {/* Footer Section */}
            <FooterSection />
        </div>
    );
};

export default HomeScreen;
